module.exports = __webpack_public_path__ + "static/media/home-description-background.cbd21400.png";